import { DataHeader, DataSource, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutWireCodeDetail extends Layout {
    dataheaderWireCodeDetail: DataHeader;
    panelContractNum: Panel;
    panelFees: Panel;
    panelGeneral: Panel;
    panelLimits: Panel;
    panelSubAccount: Panel;
    panelUsers: Panel;
    sourceWireFee: DataSource;
    sourceWirecodeDetail: DataSource;
    sourceWirecodeUsers: DataSource;
    switchAllowAfterXferToSettlement: Switch;
    switchCreateDeduction: Switch;
    switchCreateOtherCharge: Switch;
    switchIncludeProviderFee: Switch;
    switchIsActive: Switch;
    switchOtherChargeIncludeProvider: Switch;
    switchRequireOrderNumber: Switch;
    switchValidations: Switch;
    tabCarriers: Tab;
    tabCompanyDrivers: Tab;
    tabContracts: Tab;
    tabFees: Tab;
    tabGeneral: Tab;
    tabLimits: Tab;
    tabOwnerOperators: Tab;
    tabSubaccounts: Tab;
    tabUsers: Tab;
    tableWireFeeStructure: Table;
    tabsetLimitsByType: Tabset;
    tabsetWireCodeDetail: Tabset;
    textboxApGlid: Textbox;
    textboxCarrierLimitAmount: Textbox;
    textboxCarrierLimitMethod: Textbox;
    textboxCarrierOrderPctLimit: Textbox;
    textboxCarrierValidMoveStatus: Textbox;
    textboxChargeCodeId: Textbox;
    textboxCompanyLimitAmount: Textbox;
    textboxCompanyLimitMethod: Textbox;
    textboxCompanyOrderPctLimit: Textbox;
    textboxCompanyValidMoveStatus: Textbox;
    textboxContractCarrier: Textbox;
    textboxContractDriver: Textbox;
    textboxContractNoPayee: Textbox;
    textboxContractOwnerop: Textbox;
    textboxDeductCodeId: Textbox;
    textboxDeductStatus: Textbox;
    textboxDescr: Textbox;
    textboxExpenseGlid: Textbox;
    textboxFuelInterfaceId: Textbox;
    textboxIssuingUserGroup: Textbox;
    textboxIssuingUsers: Textbox;
    textboxOwneropLimitAmount: Textbox;
    textboxOwneropLimitMethod: Textbox;
    textboxOwneropOrderPctLimit: Textbox;
    textboxOwneropValidMoveStatus: Textbox;
    textboxPlusMinus: Textbox;
    textboxSubaccountCarrier: Textbox;
    textboxSubaccountDriver: Textbox;
    textboxSubaccountNoPayee: Textbox;
    textboxSubaccountOwnerop: Textbox;
    textboxUnpostedWireStatus: Textbox;
    textboxWireCode: Textbox;
    textboxWireType: Textbox;
}
